module.exports = __webpack_public_path__ + "static/media/12.739eac0a.jpg";